import { useState, ChangeEvent, FormEvent } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { ButtonTypes } from "@iddataweb/idw-common-ui/enums";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { DefaultModal } from "@containers/common/modals/default-modal/default-modal";
import { TextareaFormGroup } from "@containers/common/textarea-form-group/textarea-form-group";
import styles from "./update-template-json-modal.less";

type UpdateTemplateJSONModalProps = {
    onModalClose: () => void;
    templateString: string;
    updateTemplateString: (templateString: string) => void;
};

export const UpdateTemplateJSONModal = (props: UpdateTemplateJSONModalProps) => {
    const {
        onModalClose,
        templateString,
        updateTemplateString
    } = props;

    const [jsonValidationError, setJsonValidationError] = useState(null);
    const [templateStringState, setTemplateStringState] = useState(templateString);

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        setJsonValidationError(null);

        let parsedJSON;
        try {
            parsedJSON = JSON.parse(templateStringState);
        } catch (error) {
            setJsonValidationError(error);
        }

        if (parsedJSON) {
            updateTemplateString(templateStringState);
            onModalClose();
        }
    };

    const onTemplateStringChange = (event: ChangeEvent<HTMLInputElement>) => {
        setTemplateStringState(event.target.value);
    };

    const resource = resources.modals.updateTemplateJSON;

    return (
        < DefaultModal
            automationId="update-template-json-modal"
            ariaLabelledBy="update-template-json-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={"update-template-json-title"} closeButton>
                    <Modal.Title>{"Update Template JSON"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TextareaFormGroup
                        className={styles.templateJsonInput}
                        controlId="update-template-template-json-input"
                        automationId="update-template-template-json-input"
                        label={resource.inputs.templateJSON.label}
                        ariaLabel={resource.inputs.templateJSON.label}
                        value={templateStringState || ""}
                        disabled={false}
                        isRequired={true}
                        onChange={onTemplateStringChange}
                        labelWidth={LabelWidthTypes.MEDIUM}
                    />
                    {jsonValidationError && (
                        <Alert variant={"danger"}>
                            <div>{resource.errors.jsonValidationError}</div>
                            <div>Error: {`${jsonValidationError}`}</div>
                        </Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button id={'update-template-json-cancel'} variant="secondary" onClick={onModalClose}>{resources.common.buttons.cancel.label}</Button>
                    <Button
                        id={'update-template-json-submit'}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                    >{resources.common.buttons.save.label}</Button>
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};